import { render, staticRenderFns } from "./Finance.vue?vue&type=template&id=4231970c&scoped=true"
import script from "./Finance.vue?vue&type=script&lang=ts"
export * from "./Finance.vue?vue&type=script&lang=ts"
import style0 from "./Finance.vue?vue&type=style&index=0&id=4231970c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4231970c",
  null
  
)

export default component.exports